import { ActionTypes, Actions } from "./actions";
import { State, getInitialState } from "./state";

const initialState = getInitialState();

const reducer = (state: State = initialState, action: Actions): State => {
  switch (action.type) {
    case ActionTypes.setSortOrder:
      const { sort } = action.payload;
      return { ...state, sort };

    case ActionTypes.setPage:
      const { page } = action.payload;
      return { ...state, page };

    case ActionTypes.setFiltersDraft:
      const { filtersDraft } = action.payload;
      return { ...state, filtersDraft };

    /* start - flights_split_bounds_us */
    case ActionTypes.setFiltersDraftOutbound:
      const { filtersDraftOutbound } = action.payload;
      return { ...state, filtersDraftOutbound };

    case ActionTypes.setFiltersDraftInbound:
      const { filtersDraftInbound } = action.payload;
      return { ...state, filtersDraftInbound };
    /* end - flights_split_bounds_us */

    case ActionTypes.applyFilters:
      return { ...state, filters: state.filtersDraft };

    /* start - flights_split_bounds_us */
    case ActionTypes.applyFiltersOutbound:
      return { ...state, filters: state.filtersDraftOutbound };

    case ActionTypes.applyFiltersInbound:
      return { ...state, filters: state.filtersDraftInbound };
    /* end - flights_split_bounds_us */

    case ActionTypes.resetFiltersDraftOutbound:
      return { ...state, filtersDraft: getInitialState().filters };

    /* start - flights_split_bounds_us */
    case ActionTypes.resetFiltersDraftOutbound:
      return { ...state, filtersDraftOutbound: getInitialState().filters };

    case ActionTypes.resetFiltersDraftInbound:
      return { ...state, filtersDraftInbound: getInitialState().filters };
    /* end - flights_split_bounds_us */

    case ActionTypes.resetFilters:
      const { filters } = getInitialState();
      return { ...state, filters: filters, filtersDraft: filters };

    /* start - flights_split_bounds_us */
    case ActionTypes.resetFiltersOutbound: {
      const { filters } = getInitialState();
      return { ...state, filters: filters, filtersDraftOutbound: filters };
    }

    case ActionTypes.resetFiltersInbound: {
      const { filters } = getInitialState();
      return { ...state, filters: filters, filtersDraftInbound: filters };
    }
    /* end - flights_split_bounds_us */

    case ActionTypes.resetFiltersButKeep:
      const filtersInitState = getInitialState().filters;
      return {
        ...state,
        filters: { ...filtersInitState, ...action.payload.filter },
        filtersDraft: { ...filtersInitState, ...action.payload.filter },
        /* start - flights_split_bounds_us */
        filtersDraftOutbound: { ...filtersInitState, ...action.payload.filter },
        filtersDraftInbound: { ...filtersInitState, ...action.payload.filter }
        /* end - flights_split_bounds_us */
      };

    case ActionTypes.setValueFromSB:
      const { searchboxVal } = action.payload;
      return { ...state, ...(searchboxVal as State) };

    case ActionTypes.resetFilter:
      const { filter } = action.payload;
      const initialState = {};
      // @ts-expect-error: Element implicitly has an 'any' type. Fix the issue timely.
      initialState[filter] = getInitialState().filters[filter];
      return {
        ...state,
        filters: { ...state.filters, ...initialState },
        filtersDraft: { ...state.filtersDraft, ...initialState }
      };

    /* start - flights_split_bounds_us */
    case ActionTypes.resetFilterOutbound: {
      const { filter } = action.payload;
      const initialState = {};
      // @ts-expect-error: Element implicitly has an 'any' type. Fix the issue timely.
      initialState[filter] = getInitialState().filters[filter];
      return {
        ...state,
        filters: { ...state.filters, ...initialState },
        filtersDraftOutbound: { ...state.filtersDraftOutbound, ...initialState }
      };
    }

    case ActionTypes.resetFilterInbound: {
      const { filter } = action.payload;
      const initialState = {};
      // @ts-expect-error: Element implicitly has an 'any' type. Fix the issue timely.
      initialState[filter] = getInitialState().filters[filter];
      return {
        ...state,
        filters: { ...state.filters, ...initialState },
        filtersDraftInbound: { ...state.filtersDraftInbound, ...initialState }
      };
    }
    /* end - flights_split_bounds_us */

    default:
      return state;
  }
};

export { reducer, getInitialState };
